import React, { useEffect, useState } from "react";
import { userData, selectedOptic } from "../../js/utils";
import { post } from "../utils/api";
import ButtonIcon from "../../components/ButtonIcon";
import DataGridView from "../components/DataGridView";

import "../css/AgentesPermisos.css";
import UsersScreen from "../components/UsersScreen";
import { useScroll } from "framer-motion";

const tokenSesion = userData ? userData.token : "";

let columnsData = [
  { name: "Id", accessor: "id", width: "60px", sortable: true },
  { name: "DNI", accessor: "dni", width: "0.5fr", sortable: false },
  { name: "Nombre", accessor: "nombre", width: "1fr", sortable: true },
  { name: "Apellidos", accessor: "apellidos", width: "1fr", sortable: true },
  { name: "Móvil", accessor: "movil", width: "0.5fr", sortable: false },
  { name: "Email", accessor: "email", width: "1fr", sortable: false },
  {
    name: "Departamento",
    accessor: "areaProfesional",
    width: "1.5fr",
    sortable: false,
  },
];

export default function AgentesPermisos(props) {
  const [usersList, setUsersList] = useState([]);
  const [userId, setUserId] = useState(-1);
  const [isUserScreenOpen, setIsUserScreenOpen] = useState(false);

  async function loadUsers() {
    let usersData = [];
    let usersJSON = [];
    let jsonQuery = { token: tokenSesion, idOptica: selectedOptic.id };

    usersJSON = await post("Configuracion/ListarAgentes.php", jsonQuery);

    if (Array.isArray(usersJSON)) {
      for (const el of usersJSON) {
        let user = {
          id: el.id,
          dni: el.dni,
          nombre: el.nombre,
          apellidos: el.apellidos,
          movil: el.movil,
          email: el.email,
          areaProfesional: el.areaProfesional,
        };

        usersData.push(user);
      }

      setUsersList(usersData);
    }
  }

  useEffect(() => {
    loadUsers();
  }, []);

  const newUser = () => {
    setUserId(-1);
    setIsUserScreenOpen(true);
  };

  const openUsersPopup = (row) => {
    setUserId(row.id);
    setIsUserScreenOpen(true);
  };

  const closeUsersPopup = () => {
    setIsUserScreenOpen(false);
  };

  if (!props.show) {
    return <></>;
  }

  return (
    <>
      <div className="settings-body-container">
        <div className="empresas-opticas">
          <span className="title-h2">Agentes y permisos</span>
          <div className="empresas-opticas-options">
            <div className="general-header-separator" />
            <ButtonIcon
              text="Nuevo agente"
              icon="/images/add-white.svg"
              onClick={() => {
                newUser();
              }}
            />
          </div>
        </div>
        <DataGridView
          columns={columnsData}
          data={usersList}
          onRowClick={openUsersPopup}
          keyField="id"
          itemsIncrement="15"
        />
      </div>
      {isUserScreenOpen && (
        <UsersScreen
          {...props}
          show={isUserScreenOpen}
          userId={userId}
          closeFunction={closeUsersPopup}
          onSave={(newId) => {
            if (newId) setUserId(newId);
            loadUsers();
          }}
          onDelete={() => {
            loadUsers();
          }}
        />
      )}
    </>
  );
}
